import * as React from 'react';
import {Search} from 'lucide-react';

type SelectSearchInputProps = {
  inputRef?: React.Ref<HTMLInputElement>;
  value: string;
  placeholder: string;
  listboxId: string;
  activeOptionId?: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onKeyDown: React.KeyboardEventHandler<HTMLInputElement>;
};

function SelectSearchInput({
  inputRef,
  value,
  placeholder,
  listboxId,
  activeOptionId,
  onChange,
  onKeyDown,
}: SelectSearchInputProps) {
  return (
    <div className="border-b border-[var(--chekin-color-gray-3)] bg-white p-2">
      <div className="relative">
        <Search
          aria-hidden="true"
          className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[var(--chekin-color-gray-2)]"
        />
        <input
          ref={inputRef}
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyDown={onKeyDown}
          autoComplete="off"
          aria-controls={listboxId}
          aria-activedescendant={activeOptionId}
          className="m-0 box-border h-9 w-full rounded-md border border-[var(--chekin-color-gray-3)] bg-white pl-8 pr-3 text-[14px] font-medium text-[var(--chekin-color-brand-navy)] outline-none transition-colors placeholder:text-[var(--chekin-color-gray-2)] hover:border-[var(--chekin-color-gray-2)] focus:border-[var(--chekin-color-brand-blue)] focus:ring-2 focus:ring-[var(--chekin-color-brand-blue)]/15"
        />
      </div>
    </div>
  );
}

export {SelectSearchInput};
export type {SelectSearchInputProps};
